import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/environmental-cleaning/')({
  component: () => <Navigate to="/environmental-cleaning/missions" />,
});
